// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.mat-mdc-checkbox {
  display: flex;
  align-content: flex-start;
  margin: 10px 8px auto 0;
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
}
.mat-mdc-checkbox .mat-checkbox-layout {
  white-space: normal;
}
.mat-mdc-checkbox .mat-checkbox-inner-container {
  margin-top: 5px;
}

mat-tab-group .mdc-tab {
  font-weight: bold;
  color: #000000;
}
mat-tab-group .mdc-tab--active {
  color: #0066b2;
}

mat-expansion-panel-header .mat-content {
  flex: 0;
  flex-basis: content;
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dictionary-toolbar {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 3% 0;
  min-width: 0;
  width: 100%;
}

.dictionary-toolbar__filter {
  flex: 0 1 220px;
  max-width: 220px;
  min-width: 180px;
}

.dictionary-toolbar__clear,
.dictionary-toolbar__actions,
.dictionary-toolbar__create,
.dictionary-toolbar__export,
.dictionary-toolbar__toggle {
  flex: 0 0 auto;
}

.dictionary-toolbar__clear button,
.dictionary-toolbar__create {
  background-color: white;
  border: none;
  color: #0066b2;
  cursor: pointer;
  white-space: nowrap;
}

.dictionary-toolbar__clear button:disabled {
  box-shadow: none;
  color: #707070;
  cursor: default;
}

.dictionary-toolbar__search {
  align-items: center;
  display: flex;
  flex: 1 1 320px;
  max-width: 680px;
  min-width: 280px;
}

.dictionary-toolbar__search-field {
  align-items: center;
  border: 1px solid #707070;
  display: flex;
  flex: 1 1 auto;
  height: 48px;
  min-width: 0;
}

.dictionary-toolbar__search-field input {
  border: none;
  flex: 1 1 auto;
  font-size: 14px;
  height: 100%;
  min-width: 0;
  outline: none;
  padding: 0 8px;
}

.dictionary-toolbar__clear-search {
  background: transparent;
  border: none;
  color: #0066b2;
  cursor: pointer;
  flex: 0 0 44px;
  height: 40px;
  margin: 0;
}

.dictionary-toolbar__clear-search:hover {
  color: #0b2d71;
}

.dictionary-toolbar__search-button {
  align-items: center;
  background: #0066b2;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  flex: 0 0 60px;
  height: 48px;
  justify-content: center;
}

.dictionary-toolbar__search-button:hover {
  background-color: #0b2d71;
}

.dictionary-toolbar__actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-end;
  margin-left: auto;
}

.dictionary-toolbar__toggle,
.dictionary-toolbar__create {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.dictionary-toolbar__create {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  min-height: 44px;
  padding: 8px 12px;
}

@media (max-width: 900px) {
  .dictionary-toolbar__search {
    max-width: none;
  }
  .dictionary-toolbar__actions {
    justify-content: flex-start;
    margin-left: 0;
    width: 100%;
  }
}
/* Wide modal styling for Rating Class and Design Code modals */
.wide-modal .mat-mdc-dialog-container {
  max-width: 1000px;
  width: 90vw;
}

/* Consolidation Mapping add/edit modal */
.consolidation-mapping-modal .mat-mdc-dialog-container {
  width: 600px;
  max-width: 95vw;
}

/* Large component catalog modal styling */
.large-component-catalog-modal .mat-dialog-container {
  padding: 16px;
  height: 90vh;
  max-height: 95vh;
  /* Strong overrides to make the catalog component fill the dialog when used as a modal */
  overflow: auto;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container {
  padding: 8px;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner,
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner * {
  box-sizing: border-box;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  margin: 0;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .table-container {
  width: 100%;
  min-width: 0;
  display: block;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .table-inner {
  width: 100%;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .catalog-table {
  width: 100%;
  min-width: 0;
  table-layout: auto;
}

/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
mat-chip.mat-mdc-chip.mat-mdc-standard-chip {
  background-color: #0066b2;
  color: white;
}

mat-radio-button .mat-mdc-radio-button .mat-radio-outer-circle {
  height: 15px;
  width: 15px;
  border-color: #0066b2;
}
mat-radio-button .mat-mdc-radio-button .mat-radio-label-content {
  font-size: 9px;
  padding-left: 0px;
}
mat-radio-button .mat-mdc-radio-button .mat-radio-label {
  white-space: inherit;
  vertical-align: 0%;
  line-height: initial;
}

.mat-select-panel mat-option.mat-mdc-option {
  margin: auto 0;
  padding: 10px 20px;
  overflow: visible;
  line-height: 130%;
  word-wrap: break-word;
  white-space: pre-wrap;
  height: 100%;
}

.mat-mdc-select-panel.common-notes-panel {
  max-width: none;
  min-width: 100%;
  width: 100%;
  max-height: 250px;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option {
  min-height: 56px;
  height: auto;
  padding: 12px 20px;
  line-height: 1.5;
  max-width: 100%;
  width: 100%;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option .mdc-list-item__primary-text {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-wrap: break-word;
  max-width: 100%;
  width: 100%;
  display: block;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option-text {
  width: 100%;
  max-width: 100%;
}

.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value mat-chip-grid,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value mat-chip-row,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value .mat-mdc-chip-set,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value .mat-mdc-chip {
  display: none;
}

.dropdown-close-button {
  position: sticky;
  bottom: 0;
  display: block;
  width: 100%;
  padding: 14px 16px;
  text-align: center;
  background-color: #0066CC;
  color: white;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  z-index: 100;
  transition: background-color 0.2s;
  margin: 0;
  border-radius: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.dropdown-close-button:hover {
  background-color: #0052A3;
}

.mat-snack-bar-warning .mdc-snackbar__surface {
  background: rgb(255, 248, 115);
}

.mat-snack-bar-warning .mdc-snackbar__label {
  color: black;
  font-weight: bold;
}

.mat-snack-bar-error {
  background-color: #97002e;
}
.mat-snack-bar-error .mdc-snackbar__surface {
  --mat-snackbar-container-color: \$esra-red;
  --mat-mdc-snack-bar-button-color: rgb(250, 193, 192);
}

.mat-mdc-card {
  box-shadow: none;
}

#pttable .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading {
  width: 1px;
}

#pttable .mdc-text-field--outlined {
  padding-left: 1px;
  padding-right: 1px;
}

.dialogButtons {
  padding-top: 10px;
  float: right;
}

.button-blue {
  background-color: #0066b2;
  border: 1px solid #0066b2;
  color: #ffffff;
}
.button-blue:hover {
  background-color: #0b2d71;
  cursor: pointer;
}

.button {
  margin: none;
}

.text-button {
  display: inline-block;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
}
.text-button:hover {
  color: #0b2d71;
  box-shadow: inset 0 -2px 0 0 #0b2d71;
}

.close-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}
.close-button::before {
  font-family: "Material Icons";
  content: "close";
}
.close-button:hover {
  background-color: rgba(0, 0, 0, 0.16);
  color: #0b2d71;
}

:root ngx-slider {
  transition: none;
  margin: 15px 0px;
  height: 40px;
}
:root ngx-slider .ngx-slider-pointer {
  width: 12px;
  height: 12px;
  top: auto;
  bottom: 26px;
  background-color: #0066b2;
}
:root ngx-slider .ngx-slider-bubble {
  top: auto;
  bottom: 0px;
}
:root ngx-slider .ngx-slider-span {
  color: rgba(0, 0, 0, 0.8705882353);
  font: normal normal medium "Gotham", Arial, sans-serif;
  font-size: 11px;
}
:root ngx-slider .ngx-slider-pointer:after {
  display: none;
}
:root ngx-slider .ngx-slider-bar {
  height: 2px;
  background: rgba(125, 127, 134, 0.7019607843);
  top: auto;
  bottom: 7px;
}
:root ngx-slider .ngx-slider-selection {
  background: #0066b2;
  top: auto;
  bottom: 7px;
}

app-welding-search .mat-mdc-paginator .mat-mdc-paginator-container {
  display: flex;
  justify-content: center;
}

/* You can add global styles to this file, and also import other style files */
.left-align {
  float: left;
}

.right-align {
  float: right;
}

.text-left-align {
  text-align: left;
}

.text-right-align {
  text-align: right;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.dialogClose {
  float: right;
  cursor: pointer;
}

.dialogClose div {
  text-align: center;
  margin-top: -6px;
}

.dialogmainheader {
  padding-top: 30px;
}

.dialogmain {
  border: 1px solid gray;
  min-height: 300px;
  max-height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: -15px;
}

.button:enabled,
.primary:enabled,
.secondary:enabled {
  border: 1px solid #0066b2;
}

.button:disabled,
.primary:disabled,
.secondary:disabled {
  border: 1px solid #e3e3e3;
  cursor: default;
}

.container-horizontal {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.required:after {
  content: " *";
  color: red;
}

.pointer {
  cursor: pointer;
}

.progress-bar-container {
  min-height: 6px;
  margin: 1.5rem 3%;
}
.progress-bar-container div {
  height: 5px;
}

.esra-select {
  width: 80%;
}

.width-10 {
  width: 10%;
}

.esra-tooltip {
  --mat-tooltip-supporting-text-size: 0.875rem;
}
.esra-tooltip .mat-mdc-tooltip-surface {
  white-space: pre-line !important;
  max-width: 240px !important;
}

.edit-color {
  color: #0066b2;
}

.delete-color {
  color: #e21836;
}

.mat-sort-header-arrow {
  opacity: 1;
  transform: none;
  color: black;
}

.wrapped-text {
  padding: 1% 0;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.pad-LR-20 {
  padding-left: 20px;
  padding-right: 20px;
}

header,
nav#site-specific-nav,
nav#site-specific-nav.centered-nav,
main,
main.container,
menu,
footer {
  min-width: 85vw;
  min-width: 85dvw;
  max-width: 100vw;
  max-width: 100dvw;
}

.menu-list,
nav#site-specific-nav ul:not(.in-mega) > li .mega-menu,
nav#site-specific-nav ul:not(.in-mega) > li ul:not(.in-mega) {
  width: 100%;
  min-width: 0;
}

.service-selection-dialog .mat-mdc-dialog-container {
  padding: 0;
}
@media (max-width: 768px) {
  .service-selection-dialog .mat-mdc-dialog-container {
    margin: 20px;
    max-width: calc(100vw - 40px);
    max-height: calc(100vh - 40px);
  }
}
@media (max-width: 480px) {
  .service-selection-dialog .mat-mdc-dialog-container {
    margin: 10px;
    max-width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
  }
}
.service-selection-dialog .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  overflow: visible;
}

@media (max-width: 768px) {
  .mat-mdc-dialog-container {
    border-radius: 8px;
  }
}
@media (max-width: 480px) {
  .mat-mdc-dialog-container {
    border-radius: 4px;
  }
}

/* Extra large catalog modal */
.xlarge-component-catalog-modal .mat-dialog-container,
.xlarge-component-catalog-modal .mat-mdc-dialog-container {
  padding: 0;
  width: 100vw;
  max-width: 100vw;
  height: 95vh;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.xlarge-component-catalog-modal .mat-dialog-content,
.xlarge-component-catalog-modal .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}

.xlarge-component-catalog-modal .mat-dialog-actions,
.xlarge-component-catalog-modal .mat-mdc-dialog-actions {
  flex-shrink: 0;
  flex-grow: 0;
  margin: 0;
  padding: 0;
  min-height: auto;
}

/* Slightly larger typography and controls inside the modal for easier selection */
.xlarge-component-catalog-modal table {
  font-size: 1.05rem;
}

.xlarge-component-catalog-modal .mat-form-field,
.xlarge-component-catalog-modal .search-input-container {
  transform: scale(1.02);
}

/* When the catalog component is hosted inside a modal use these styles */
.table-container.modal-mode {
  display: flex;
  flex-direction: column;
  height: 90%; /* occupy 90% of the dialog */
}

.table-container.modal-mode .table-inner {
  flex: 1 1 auto;
  min-height: 0; /* allow flex child to shrink for scrolling */
  overflow: auto;
  /* ensure horizontal scrolling is possible and visible */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-container.modal-mode .catalog-table {
  /* Allow the table to be wider than the dialog so users get a spacious layout
     and can horizontally scroll inside the modal. Increase min-width to better
     match the dialog's larger layout. */
  width: auto; /* let content set the width */
  min-width: 0; /* don't force a large min-width in modal; allow dialog to constrain width */
  table-layout: auto; /* allow columns to size naturally */
}

/* Optional: style the horizontal scrollbar inside the table-inner for clarity */
.table-container.modal-mode .table-inner::-webkit-scrollbar {
  height: 12px;
}

.table-container.modal-mode .table-inner::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.table-container.modal-mode .modal-confirm-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

/* Make the middle area wider in the extra-large catalog modal: place filters and
   table side-by-side and let the table take the remaining width. */
.xlarge-component-catalog-modal .main-conatiner .middle-container {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.xlarge-component-catalog-modal .main-conatiner .filter-group-container {
  /* keep filter column compact in modal so table has more room */
  flex: 0 0 260px;
  max-width: 260px;
}

.xlarge-component-catalog-modal .main-conatiner .table-container {
  /* allow table container to expand and use modal-mode rules for internal scrolling */
  flex: 1 1 auto;
  min-width: 0; /* allow flex child to shrink for proper overflow handling */
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.ribbon-wrap {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.corner-ribbon {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateX(30%) rotate(-45deg);
  transform-origin: bottom left;
  margin: 0;
  padding: 7px 0;
  width: 110px;
  text-align: center;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 11px;
  letter-spacing: 0.5px;
  color: white;
  pointer-events: auto;
  cursor: default;
}
.corner-ribbon::before, .corner-ribbon::after {
  content: "";
  position: absolute;
  top: 0;
  margin: 0 -1px;
  width: 100%;
  height: 100%;
}
.corner-ribbon::before {
  right: 100%;
}
.corner-ribbon::after {
  left: 100%;
}
.corner-ribbon.corner-ribbon--draft {
  background-color: #e65100;
}
.corner-ribbon.corner-ribbon--draft::before, .corner-ribbon.corner-ribbon--draft::after {
  background: #e65100;
}
.corner-ribbon.corner-ribbon--retired {
  background-color: #97002e;
}
.corner-ribbon.corner-ribbon--retired::before, .corner-ribbon.corner-ribbon--retired::after {
  background: #97002e;
}
.corner-ribbon.corner-ribbon--archived {
  background-color: #8c8f93;
}
.corner-ribbon.corner-ribbon--archived::before, .corner-ribbon.corner-ribbon--archived::after {
  background: #8c8f93;
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  display: flex;
  flex-direction: column;
  margin-top: 2%;
}

#mat-group-wrapper {
  width: 93%;
}

mat-panel-title {
  color: #0066b2;
  font-size: 1rem;
}

mat-expansion-panel-header {
  font-weight: bolder;
}

table.mat-mdc-table {
  width: 100%;
}

table tr th {
  background: #f7f7f7;
}

table tr td {
  background: none;
}

#piping-summary tr th {
  border: 1px solid silver;
  width: 10%;
  white-space: nowrap;
}

#piping-summary tr td {
  border: 1px solid silver;
  white-space: nowrap;
}

button {
  font-weight: bold;
}

h6 {
  color: black;
  float: left;
}

.property-value {
  font-weight: 500;
}

.property-edition {
  color: #666;
  font-size: 0.9em;
  font-style: italic;
  margin-left: 0.5em;
}

.cell-content-with-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.content-left {
  flex: 1;
}

.edit-buttons-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.edit-text-link {
  cursor: pointer;
  color: #1976d2;
}
.edit-text-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.edit-text-link:hover {
  color: #0d47a1;
}
.edit-text-link.inline-add {
  margin-left: 4px;
}
.edit-text-link.inline-add mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}

.edit-notes-link {
  cursor: pointer;
  color: #1976d2;
}
.edit-notes-link.inline-add {
  margin-left: 4px;
}
.edit-notes-link.inline-add mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
.edit-notes-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.edit-notes-link:hover {
  color: #0d47a1;
}

:host::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  font-weight: bolder;
  color: black;
}

.pipe-summary-note {
  font-size: 16px;
  letter-spacing: 0.5px;
}

table tr th, table tr td {
  padding: 10px 8px;
}

.services-list {
  padding-left: 2%;
}

.note-element {
  color: #0066b2;
}

.note-element:hover {
  cursor: pointer;
  text-decoration: underline;
  font-weight: bolder;
}

.ptt-modal {
  float: right;
}

.edit-inline-btn {
  margin-left: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
  width: 24px;
  height: 24px;
}
.edit-inline-btn .mat-icon {
  font-size: 16px;
  line-height: 16px;
}

.edit-text-link {
  margin-left: 8px;
  font-size: 12px;
  font-weight: normal;
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}
.edit-text-link:hover {
  text-decoration: underline;
}
.edit-text-link:focus {
  outline: 1px dotted #1976d2;
  outline-offset: 2px;
}
.edit-text-link .home-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  margin-right: 4px;
  color: inherit;
}

.edit-notes-link {
  margin-left: 8px;
  color: #1976d2;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.edit-notes-link:hover {
  color: #0d47a1;
}
.edit-notes-link:focus {
  outline: 1px dotted #1976d2;
  outline-offset: 2px;
}

.small-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

td:hover .edit-inline-btn {
  opacity: 1;
}

.inline-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 250px;
}

.inline-form {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.compact-field {
  flex: 1;
  min-width: 150px;
}
.compact-field .mat-mdc-form-field-wrapper {
  padding-bottom: 0;
}
.compact-field .mat-mdc-text-field-wrapper {
  height: 36px;
}
.compact-field .mat-mdc-form-field-infix {
  min-height: 28px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.compact-field input {
  font-size: 14px;
}

.inline-buttons {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.inline-buttons button {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.inline-buttons button .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

.temperature-fields {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
.temperature-fields .mat-form-field {
  min-width: 120px;
  max-width: 150px;
}

.temperature-separator {
  color: #666;
  font-size: 14px;
  padding: 0 4px;
  white-space: nowrap;
}

.table-header-controls {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fafafa;
}

.edit-mode-controls {
  display: flex;
  align-items: center;
}

.edit-mode-button {
  color: #1976d2;
  font-weight: 500;
}
.edit-mode-button .mat-icon {
  margin-right: 4px;
}
.edit-mode-button:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.cancel-edit-button {
  color: #d32f2f;
  font-weight: 500;
}
.cancel-edit-button .mat-icon {
  margin-right: 4px;
}
.cancel-edit-button:hover {
  background-color: rgba(211, 47, 47, 0.04);
}

.services-list ul {
  list-style: none;
  padding: 0;
  margin: 8px 0;
}

.service-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  margin: 4px 0;
  border-radius: 4px;
  background-color: #f9f9f9;
  position: relative;
}
.service-item:hover {
  background-color: #f0f0f0;
}

.service-name {
  font-size: 14px;
  margin-right: 12px;
  flex-shrink: 0;
}

.delete-service-button {
  width: 32px;
  height: 32px;
  min-width: 32px;
  position: absolute;
  left: calc(20% + 80px);
}
.delete-service-button .mat-icon {
  font-size: 18px;
  line-height: 18px;
}

.add-service-section {
  margin-bottom: 16px;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.add-service-button-container {
  display: flex;
  justify-content: flex-start;
}

.add-service-button {
  color: #1976d2;
  font-weight: 500;
}
.add-service-button .mat-icon {
  margin-right: 8px;
}
.add-service-button:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.add-service-form {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 8px;
}

.service-input {
  flex-grow: 1;
  max-width: 300px;
}

.service-form-buttons {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.service-form-buttons button {
  width: 32px;
  height: 32px;
}
.service-form-buttons button .mat-icon {
  font-size: 18px;
  line-height: 18px;
}

.notes-section {
  margin-top: 20px;
  padding: 15px;
  background-color: white;
}
.notes-section .notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.notes-section .notes-header h3 {
  margin: 0;
  color: #0066b2;
  font-size: 16px;
  font-weight: bold;
}
.notes-section .notes-header .add-notes-section .add-notes-button-container {
  display: flex;
  justify-content: flex-end;
}
.notes-section .notes-header .add-notes-section .add-notes-button-container .add-notes-button {
  color: #1976d2;
  font-weight: 500;
}
.notes-section .notes-header .add-notes-section .add-notes-button-container .add-notes-button:hover {
  background-color: rgba(25, 118, 210, 0.04);
}
.notes-section .notes-header .add-notes-section .add-notes-button-container .add-notes-button .mat-icon {
  margin-right: 8px;
}
.notes-section .notes-list .note-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #eeeeee;
}
.notes-section .notes-list .note-item:last-child {
  border-bottom: none;
}
.notes-section .notes-list .note-item .note-content {
  flex: 1;
  margin-right: 10px;
}
.notes-section .notes-list .note-item .note-content .note-code {
  font-weight: bold;
  color: #0066b2;
  font-size: 14px;
}
.notes-section .notes-list .note-item .note-content .note-text {
  color: #333;
  line-height: 1.4;
  font-size: 14px;
}
.notes-section .notes-list .note-item .note-content .note-category {
  color: #666;
  font-size: 12px;
  font-style: italic;
  margin-left: 8px;
}
.notes-section .notes-list .note-item .note-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.notes-section .notes-list .note-item .note-actions .edit-note-button,
.notes-section .notes-list .note-item .note-actions .delete-note-button {
  min-width: 40px;
  height: 40px;
}
.notes-section .notes-list .note-item .delete-note-button {
  flex-shrink: 0;
  min-width: 40px;
  height: 40px;
}
.notes-section .notes-list .note-item .delete-note-button .mat-icon {
  font-size: 18px;
}
.notes-section .notes-list .note-item .delete-note-button:hover {
  background-color: rgba(244, 67, 54, 0.1);
}
.notes-section .notes-list .no-notes-message {
  padding: 20px;
  text-align: center;
  color: #666;
  font-style: italic;
  background-color: white;
  border: 2px solid black;
  border-radius: 4px;
}

.service-display .main-service {
  font-weight: 500;
  color: #333;
}
.service-display .additional-services {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.service-display .additional-services .service-tag {
  display: inline-flex;
  align-items: center;
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.85rem;
  border: 1px solid #bbdefb;
}
.service-display .additional-services .service-tag .remove-service {
  margin-left: 6px;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.service-display .additional-services .service-tag .remove-service:hover {
  opacity: 1;
  color: #d32f2f;
}

.edit-text-link {
  color: #1976d2;
  cursor: pointer;
  font-size: 0.9rem;
  margin-left: 12px;
  display: inline-flex;
  align-items: center;
}
.edit-text-link mat-icon {
  margin-left: 4px;
  font-size: 18px;
}
.edit-text-link:hover {
  color: #1565c0;
  text-decoration: underline;
}

.ptt-header {
  margin: 16px 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ptt-header .delete-table-button {
  display: flex;
  align-items: flex-end;
  color: #d32f2f;
}
.ptt-header .delete-table-button:hover {
  background-color: rgba(211, 47, 47, 0.1);
}
.ptt-header .delete-table-button mat-icon {
  font-size: 20px;
}
.ptt-header .fetch-data-button {
  display: flex;
  align-items: flex-end;
  color: #1976d2;
  outline: none;
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.ptt-header .fetch-data-button mat-icon {
  font-size: 20px;
  color: #1976d2;
  background-color: transparent;
  outline: none;
  box-shadow: none;
}
.ptt-header .fetch-data-button.ptt-sync-button {
  transition: all 0.2s ease-in-out;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-available {
  color: #ff9800;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-available mat-icon {
  color: #ff9800;
  animation: rotate 1s ease-in-out;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-available:hover {
  color: #f57c00;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-available:hover mat-icon {
  color: #f57c00;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-current {
  color: #4caf50;
  cursor: default;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-current mat-icon {
  color: #4caf50;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-loading {
  color: #2196f3;
  cursor: wait;
}
.ptt-header .fetch-data-button.ptt-sync-button.sync-loading mat-spinner {
  color: #2196f3;
}
.ptt-header .fetch-data-button.ptt-sync-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ptt-header .ptt-title {
  flex-grow: 0;
  text-align: left;
}
.ptt-header .ptt-title .table-value {
  font-size: 1rem;
  font-weight: 500;
  color: #0066b2;
}
.ptt-header .ptt-title .ptt-name-link {
  padding: 0 4px;
  min-width: 0;
  line-height: normal;
  height: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.ptt-header .ptt-title .ptt-name-link .table-value {
  text-decoration: underline;
  text-underline-offset: 2px;
}
.ptt-header .ptt-title .ptt-name-link .ptt-edit-icon {
  font-size: 0.9rem;
  width: 0.9rem;
  height: 0.9rem;
  color: #0066b2;
  opacity: 0.7;
}
.ptt-header .ptt-title .ptt-name-link:hover .ptt-edit-icon {
  opacity: 1;
}

.ptt-hydrotest-notes {
  margin: 12px 0 16px 0;
}
.ptt-hydrotest-notes .mat-mdc-form-field {
  width: 100%;
}
.ptt-hydrotest-notes .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: #fff;
}
.ptt-hydrotest-notes mat-label {
  color: #1976d2;
  font-weight: 500;
}
.ptt-hydrotest-notes textarea {
  resize: vertical;
  min-height: 60px;
}
.ptt-hydrotest-notes .mat-mdc-form-field-hint {
  color: #666;
  font-size: 12px;
}
.ptt-hydrotest-notes .ptt-sync-warning {
  color: #ff9800;
  font-weight: 500;
}

.ptt-hydrotest-notes-display {
  margin: 12px 0 16px 0;
  padding: 12px;
  background-color: #f5f5f5;
  border-left: 4px solid #1976d2;
  border-radius: 4px;
}
.ptt-hydrotest-notes-display .notes-header {
  color: #1976d2;
  font-weight: 500;
  margin: 0 0 8px 0;
}
.ptt-hydrotest-notes-display .additional-notes {
  margin: 0;
}
.ptt-hydrotest-notes-display .additional-notes p {
  margin: 0;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ptt-notes-section {
  margin: 16px 0;
  padding: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.ptt-notes-section .ptt-notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.ptt-notes-section .ptt-notes-header .notes-header {
  margin: 0;
  font-weight: 600;
  color: #333;
}
.ptt-notes-section .ptt-notes-header .add-ptt-notes-button {
  color: #1976d2;
  border: 1px solid #1976d2;
}
.ptt-notes-section .ptt-notes-header .add-ptt-notes-button mat-icon {
  margin-right: 4px;
}
.ptt-notes-section .ptt-notes-header .add-ptt-notes-button:hover {
  background-color: #e3f2fd;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .note-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .note-content .note-element {
  font-weight: 600;
  color: #1976d2;
  flex: 1;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .note-content .note-source-badge {
  font-size: 11px;
  padding: 2px 6px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 12px;
  color: #666;
  margin-left: 8px;
  white-space: nowrap;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .note-content .note-actions {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .note-content .note-actions button {
  min-width: auto;
  width: 28px;
  height: 28px;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .note-content .note-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .delete-note-button {
  flex-shrink: 0;
  margin-left: 8px;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item .delete-note-button mat-icon {
  font-size: 18px;
}
.ptt-notes-section .ptt-notes-list .ptt-note-item:last-child {
  margin-bottom: 0;
}

.services-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 15px;
}
.services-header h3 {
  margin: 0;
  color: #0066b2;
  font-size: 16px;
  font-weight: bold;
}
.services-header .add-service-section .add-service-button-container {
  display: flex;
  justify-content: flex-end;
}
.services-header .add-service-section .add-service-button-container .add-service-button {
  color: #1976d2;
  font-weight: 500;
}
.services-header .add-service-section .add-service-button-container .add-service-button:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.summary-actions {
  margin-top: 30px;
  padding: 20px 0;
  border-top: 1px solid #e0e0e0;
}
.summary-actions .action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
.summary-actions .action-buttons .cancel-btn {
  border: 1px solid #0066b2;
  color: #0066b2;
  background-color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.summary-actions .action-buttons .cancel-btn:hover {
  background-color: rgba(0, 102, 178, 0.04);
}
.summary-actions .action-buttons .save-btn {
  background-color: #0066b2;
  color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.summary-actions .action-buttons .save-btn:hover {
  background-color: rgb(0, 72.7752808989, 127);
}

.ptt-additional-notes-section {
  margin: 16px 0;
  padding: 12px;
  border-left: 3px solid #0066b2;
  background-color: rgba(0, 102, 178, 0.02);
  border-radius: 4px;
}
.ptt-additional-notes-section .ptt-additional-notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.ptt-additional-notes-section .ptt-additional-notes-header .notes-header {
  margin: 0;
  font-weight: 600;
  color: #0066b2;
  font-size: 14px;
}
.ptt-additional-notes-section .ptt-additional-notes-header .add-additional-note-button {
  min-width: auto;
  width: 32px;
  height: 32px;
}
.ptt-additional-notes-section .ptt-additional-notes-header .add-additional-note-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-content .note-text {
  flex: 1;
  padding: 4px 8px;
  color: #333;
  font-size: 13px;
  line-height: 1.4;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-content .note-source-badge {
  font-size: 11px;
  padding: 2px 6px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 12px;
  color: #666;
  margin-left: 8px;
  white-space: nowrap;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-content .note-actions {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-content .note-actions button {
  min-width: auto;
  width: 28px;
  height: 28px;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-content .note-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-edit-mode {
  width: 100%;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-edit-mode mat-form-field {
  width: 100%;
  margin-bottom: 8px;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-edit-mode .edit-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.ptt-additional-notes-section .additional-notes-list .additional-note-item .note-edit-mode .edit-actions button {
  min-width: auto;
  width: 32px;
  height: 32px;
}
.ptt-additional-notes-section .add-note-form {
  margin-top: 12px;
  padding: 12px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}
.ptt-additional-notes-section .add-note-form mat-form-field {
  width: 100%;
  margin-bottom: 8px;
}
.ptt-additional-notes-section .add-note-form .add-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.ptt-additional-notes-section .add-note-form .add-actions button {
  min-width: auto;
  width: 32px;
  height: 32px;
}
.ptt-additional-notes-section .no-additional-notes {
  padding: 8px;
  text-align: center;
  color: #666;
  font-style: italic;
  font-size: 13px;
}
.ptt-additional-notes-section .no-additional-notes .empty-state-message {
  margin: 0;
}

.ptt-compare-notes-section {
  margin: 8px 0;
}
.ptt-compare-notes-section .notes-header {
  font-size: 0.85em;
  font-weight: bold;
  margin-bottom: 4px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
